import { ColumnDataType, Provider, WorkflowComponentParamType } from '../types';
import { addColumn } from '../utils/schemas';
import { SelectWorkflowComponent } from './common/selectcomponent';
class QuadbinCenter extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'native.quadbincenter',
            group: 'Spatial Indexes',
            title: 'Quadbin Center',
            description: `
      This component adds a new column containing the centers of Quadbin cells.
      `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'quadbincol',
                type: WorkflowComponentParamType.Column,
                title: 'Quadbin column',
                parent: 'source',
                placeholder: 'quadbin',
                dataType: [ColumnDataType.Number]
            }
        ]);
    }
    getInnerSql({ params, connection, envVars }) {
        if (connection.type === Provider.DatabricksRest) {
            return `SELECT /*+ REPARTITION(40, geom) */
                *,
                ${connection.processOutputGeogColumn(`ST_GEOMFROMTEXT(QUADBIN_CENTER(
                    ${params.quadbincol}
                ))`)} geom
              FROM ${connection.quoteName(params.source)}`;
        }
        else {
            return `SELECT *,
              ${connection.quoteName(envVars.analyticsToolboxDataset)}.QUADBIN_CENTER(
                  ${params.quadbincol}
                ) geom
              FROM ${connection.quoteName(params.source)}`;
        }
    }
    requiredAnalyticsToolboxVersion(provider) {
        return '1.0.0';
    }
    getVersion(provider) {
        return '1.1';
    }
    canProvideOutputSchemas() {
        return true;
    }
    getOutputSchema({ columns, connection }) {
        return addColumn(columns.source, {
            name: 'geom',
            type: connection.getGeoDataType()
        });
    }
}
export { QuadbinCenter };
